'use strict';

const \uD504\uB85C\uB355\uC158\uC774_\uC544\uB2CC\uAC00 = (configurations) => {
  if (configurations.stage === "prod") {
    return false;
  }
  return true;
};
const isOrganizationChartSnapshotEnabled = \uD504\uB85C\uB355\uC158\uC774_\uC544\uB2CC\uAC00;
const isNewVersionUnusedTimeOffPaymentEnabled = \uD504\uB85C\uB355\uC158\uC774_\uC544\uB2CC\uAC00;
const isRecruitingProductionEnabled = (configurations, identifier) => {
  const ALLOWED_CUSTOMER_ID_HASH_LIST = [
    "MG0pYb9zYO",
    // 가상 플렉스
    "65Y06m8XpK"
    // 진짜 플렉스
  ];
  if (identifier === void 0) {
    return false;
  }
  if (configurations.stage !== "prod") {
    return true;
  }
  return ALLOWED_CUSTOMER_ID_HASH_LIST.includes(identifier.customerIdHash);
};
const isRecruitingLocalEnabled = (configurations) => {
  return configurations.stage === "local";
};
const isEmployeePayrollFormDownloadDisabled = (configurations, identifier) => {
  if (identifier === void 0) {
    return false;
  }
  const { customerIdHash } = identifier;
  switch (configurations.stage) {
    case "local":
    case "dev":
    case "qa":
      return false;
    case "prod":
      return [
        "VbQ8XOEX1x",
        // 밸런스히어로(27) https://flex-cv82520.slack.com/archives/C01290TR66R/p1708675905269779
        "MV0aR63zZB"
        // 코인원(26991)    https://flex-cv82520.slack.com/archives/CRU35U9FC/p1713147920925039
      ].includes(customerIdHash);
    default:
      return false;
  }
};
const getCodeBaseFeatureFlag = (configurations, codeBaseFeatureKey, _identifier) => {
  switch (codeBaseFeatureKey) {
    case "organizationChartSnapshot": {
      return isOrganizationChartSnapshotEnabled(configurations);
    }
    case "newVersionUnusedTimeOffPayment": {
      return isNewVersionUnusedTimeOffPaymentEnabled(configurations);
    }
    case "recruitingProduction": {
      return isRecruitingProductionEnabled(configurations, _identifier);
    }
    case "recruitingLocal": {
      return isRecruitingLocalEnabled(configurations);
    }
    case "employee_payroll_form_download_disabled": {
      return isEmployeePayrollFormDownloadDisabled(configurations, _identifier);
    }
    default: {
      return false;
    }
  }
};

exports.getCodeBaseFeatureFlag = getCodeBaseFeatureFlag;
//# sourceMappingURL=codeBaseFeatureDefinitions.cjs.map
